<template>
  <v-container-with-title title="QMPs creados recientemente">
    <!-- A message to show while loading the QMPs -->
    <v-loading-message v-if="loadingQmps" message="Cargando QMPs" />
    <template v-if="qmps.length">
      <!-- All the QMPs -->
      <v-layout v-if="qmps.length">
        <v-flex>
          <v-qmp-container v-for="(qmp, index) in qmps" :key="index" :qmp="qmp" />
        </v-flex>
      </v-layout>
      <!-- The pagination of the QMPS -->
      <v-layout justify-center>
        <v-flex shrink>
          <v-qmps-pagination />
        </v-flex>
      </v-layout>
    </template>
    <!-- A message to show if there are no qmps -->
    <v-layout v-if="!loadingQmps && !qmps.length" justify-center>
      <v-flex
        class="blue-grey--text font-weight-light title mt-5"
        shrink
      >No hay QMPs creados para la clasificación {{ classificationId }} y marca {{ brand }} aún.</v-flex>
    </v-layout>
  </v-container-with-title>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("matching");

import VContainerWithTitle from "@/components/containers/ContainerWithTitle";
import VLoadingMessage from "../../components/LoadingMessage";
import VQmpContainer from "./QmpContainer";
import VQmpsPagination from "./QmpsPagination";

export default {
  components: {
    VContainerWithTitle,
    VLoadingMessage,
    VQmpContainer,
    VQmpsPagination
  },
  computed: {
    ...mapState(["loadingQmps", "qmps"]),
    brand() {
      return this.$route.params.brandName;
    },
    classificationId() {
      return this.$route.params.classificationId;
    }
  },
  created() {
    this.getQmps({
      brand: this.brand,
      classificationId: this.classificationId,
      page: 1
    });
  },
  methods: {
    ...mapActions(["getQmps"])
  }
};
</script>
